export default {
  name: 'ccColors',
  energyComp: '#7a8383',
  energyAux: '#afbcbc',
  heating: '#FF6666',
  cooling: '#6699CC',
  electric: '#afbcbc',
  outdoorTemperature: '#FFCC00',
  signature: '#8e7f8f',
  energyTot: '#000000',
  cold: [
    '#6699CC',
    '#3973ac',
    '#4080bf',
    '#538cc6',
    '#6699cc',
    '#79a6d2',
    '#8cb3d9',
    '#9fbfdf'
  ],
  warm: [
    '#FF6666',
    '#ff1a1a',
    '#ff3333',
    '#ff4d4d',
    '#ff6666',
    '#ff8080',
    '#ff9999',
    '#ffb3b3'
  ]
}
